export default {
  data() {
    return {
      jsonErrors: {},
      jsonFieldToggleMap: {},
    }
  },
  methods: {
    jsonState(key) {
      return this.jsonErrors[key] ? false : null
    },
    jsonFeedback(key) {
      return this.jsonErrors[key] || ''
    },
    onJsonValidation(key, error) {
      this.$set(this.jsonErrors, key, error || '')
    },
    hasJsonErrors() {
      return Object.values(this.jsonErrors).some(e => !!e)
    },
    firstJsonErrorKey() {
      return Object.keys(this.jsonErrors).find(k => !!this.jsonErrors[k])
    },
    expandAndScrollToJsonError() {
      const fieldKey = this.firstJsonErrorKey()
      if (!fieldKey) return false

      const toggleKey = this.jsonFieldToggleMap[fieldKey]
      if (toggleKey && this.toggle && !this.toggle[toggleKey]) {
        this.$set(this.toggle, toggleKey, true)
        this.$forceUpdate()
      }

      this.$nextTick(() => {
        const el = this.$el.querySelector(`[data-json-field="${fieldKey}"]`)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' })
          const flashEl = el
          flashEl.classList.remove('tc-error-highlight')
          void flashEl.offsetWidth
          flashEl.classList.add('tc-error-highlight')
          flashEl.addEventListener('animationend', () => flashEl.classList.remove('tc-error-highlight'), { once: true })
        }
      })
      return true
    },
  },
  watch: {
    loading(newVal) {
      if (newVal) {
        this.jsonErrors = {}
      }
    }
  }
}
